var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CardText',{attrs:{"title":"Terms of services","subTitle":"for Barhopp Android & iOS App"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }